<aside id="project-summary">
  <section>
    <h6 class="k-mb-0 font-weight-medium">PROJEKTSTUNDEN</h6>
    @if (totalProjectTime() < 0) {
      <h5>Keine Projektstunden festgelegt.</h5>
    } @else {
      <ng-template
        *ngTemplateOutlet="
          doughnut;
          context: { chartData: billableDoughnutData(), labels: billableDoughnutDataLabels() }
        "
      />
    }
  </section>

  <hr />

  <section>
    <h6 class="k-mb-0 font-weight-medium">PROJEKTKOSTEN</h6>
    @if (totalProjectTime() < 0) {
      <h5>Keine Projektstunden festgelegt.</h5>
    } @else {
      <ng-template
        *ngTemplateOutlet="
          doughnut;
          context: { chartData: costDoughnutData(), labels: costDoughnutDataLabels() }
        "
      />
    }
  </section>

  <hr />

  @if (fuelBarVisible()) {
    <section class="k-mt-2">
      <div>
        <h6 class="k-mb-0 font-weight-medium">
          VERBRAUCHTES BUDGET ({{ unit() === "monetary" ? "EURO" : "STUNDEN" }})
        </h6>
        <div>
          @if (totalBudget() < 0) {
            <h5>Kein Budget festgelegt.</h5>
          } @else {
            <app-fuelbar [currentVal]="expendituresAbsolut()" [maxVal]="totalBudget()" />
            <div class="k-d-flex k-justify-content-between k-align-items-baseline k-mt-2">
              <div class="k-d-inline-flex k-align-items-baseline">
                <h3 class="font-weight-bold k-my-0">
                  <span class="remaining-budget-absolut">
                    @if (unit() === "monetary") {
                      {{ expendituresAbsolut() | shiveCurrency }}
                    } @else {
                      {{
                        expendituresAbsolut() | timeFormat: TimeFormatType.SecondsToHoursAndMinutes
                      }}
                    }
                  </span>
                </h3>
                <span class="k-ml-1.5">
                  <span
                    class="remaining-budget-in-percent font-weight-bold"
                    [class.exceeded]="expendituresInPercent() > 100"
                    >(<span class="value">{{ expendituresInPercent() | number: "1.2-2" }}%</span
                    >)</span
                  >
                </span>
              </div>
              <div class="total-budget k-font-weight-bold">
                @if (unit() === "monetary") {
                  {{ totalBudget() | shiveCurrency }}
                } @else {
                  {{ totalBudget() | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }}
                }
              </div>
            </div>
          }
        </div>
      </div>
    </section>
  }

  <hr />

  <section class="k-mt-2">
    <h6 class="k-mb-0 font-weight-medium">IN RECHNUNG GESTELLTER BETRAG</h6>
    @if (alreadyInvoiced() >= 0) {
      <div class="k-d-inline-flex k-align-items-baseline">
        <h3 class="uninvoiced-amount font-weight-bold k-my-0">
          {{ alreadyInvoiced() | shiveCurrency }}
        </h3>
        <span class="k-ml-1.5"
          >(<span class="k-font-weight-bold">{{ notInvoiced() | shiveCurrency }}</span> nicht in
          Rechnung gestellt)</span
        >
      </div>
    }
    @if (alreadyInvoiced() < 0 && notInvoiced() < 0) {
      <h5>Es gibt nichts abzurechnen.</h5>
    }

    @if (notInvoiced() > 0) {
      <div><a href="#">Rechnung erstellen</a></div>
    }
  </section>
</aside>

<ng-template #doughnut let-labels="labels" let-chartData="chartData">
  <div
    class="doughnut-grid k-d-grid k-grid-cols-[auto_1fr] k-align-items-center k-gap-x-12 k-gap-y-0 k-mt-2"
  >
    <div class="k-row-span-2">
      <kendo-chart
        style="width: 70px; height: 70px"
        [chartArea]="{ margin: 0 }"
        [seriesDefaults]="{ spacing: 0 }"
      >
        <kendo-chart-series>
          <kendo-chart-series-item
            type="donut"
            [data]="chartData"
            categoryField="kind"
            field="share"
            colorField="color"
            [padding]="0"
          >
          </kendo-chart-series-item>
        </kendo-chart-series>
        <kendo-chart-legend [visible]="false"></kendo-chart-legend>
      </kendo-chart>
    </div>
    <div class="doughnut-labels k-d-grid k-gap-x-6 k-flex-1">
      <div class="label-text k-pos-relative first-value">{{ labels[0].kind }}:</div>
      <div class="font-weight-bold k-mb-0">{{ labels[0].value }}</div>

      <div class="label-text k-pos-relative second-value">{{ labels[1].kind }}:</div>
      <div class="font-weight-bold k-mb-0">{{ labels[1].value }}</div>
    </div>
    <h3 class="summary-value font-weight-bold k-mt-1.5 k-mb-0">
      <fa-icon [icon]="faSigma"></fa-icon>
      <span class="summation k-ml-1.5">{{ labels[2].value }}</span>
    </h3>
  </div>
</ng-template>
